"use client";

import type { ReactNode } from "react";
import { ThemeProvider } from "./ThemeProvider";

/**
 * Top-level client provider stack.
 *
 * Today: just ThemeProvider. As we add auth (NextAuth SessionProvider),
 * i18n (LanguageProvider), and analytics (AppInsightsProvider), they
 * compose in here so the root layout stays clean.
 */
export default function Providers({ children }: { children: ReactNode }) {
  return <ThemeProvider>{children}</ThemeProvider>;
}
